import { useCallback, useContext } from 'react';
import { PageContext } from '#/context/PageContext';

const usePage = () => {
  const pageContext = useContext(PageContext);
  if (pageContext === undefined) {
    throw new Error('usePage must be used within a PageProvider');
  }
  const {
    getCurrentPageInfo,
    updateCurrentPageInfo,
    updateCurrentPageId
  } = pageContext;

  const getCurrentPageId = useCallback(() => {
    return getCurrentPageInfo().currentPageId;
  }, [getCurrentPageInfo]);

  const getPreviousPageId = useCallback(() => {
    return getCurrentPageInfo().previousPageId;
  }, [getCurrentPageInfo]);

  const getPageLatestStateById = useCallback(
    id => {
      const { pageLatestState } = getCurrentPageInfo();
      return pageLatestState[id];
    },
    [getCurrentPageInfo]
  );

  const setPageLatestStateById = useCallback(
    (id, state) => {
      updateCurrentPageInfo({ currentPageId: id, newState: state });
    },
    [updateCurrentPageInfo]
  );

  const setCurrentPageId = useCallback(
    currentPageId => updateCurrentPageId(currentPageId),
    [updateCurrentPageId]
  );

  return {
    getCurrentPageId,
    getPreviousPageId,
    getPageLatestStateById,
    setCurrentPageId,
    setPageLatestStateById
  };
};

export default usePage;
